$(document).ready(function () {
	setupSubmitEvents();

	function setupSubmitEvents() {
		let registrationStep1 = $('form.mylla-registration-form--step1');
		let registrationStep2 = $('form.mylla-registration-form--step2');
		$(registrationStep1).submit(function (event) {
			event.preventDefault();
			let form = $(this);
			if (form.valid()) {
				$.ajax({
					url: form.attr('action'),
					type: form.attr('method'),
					data: form.serialize(),
					success: function (result) {
						if (result.redirect) {
							window.location = result.redirect;
						}
						else {
							$('#registrationFormContainer').html(result);
							setupSubmitEvents();

							let step1SubmissionEvent = new CustomEvent("myLLARegistrationStepSubmitted");
							document.dispatchEvent(step1SubmissionEvent);

							var registrationFormErrors = $('.form__group .form-control-error.field-validation-error');
							if (registrationFormErrors.length > 0) {
								var headerHeight = $(".header-content").height();
								$("html, body").animate({ scrollTop: $(".form__group .form-control-error.field-validation-error").offset().top - headerHeight - 40 }, 1000);
							}
						}
					}
				});
			}
		});

		$(registrationStep2).submit(function (event) {
			event.preventDefault();
			let form = $(this);
			if (form.valid()) {
				$.ajax({
					url: form.attr('action'),
					type: form.attr('method'),
					data: form.serialize(),
					success: function (result) {
						if (result.redirect) {
							window.location = result.redirect;
						} else {
							$('#registrationFormContainer').html(result);
							setupSubmitEvents();

							let step2SubmissionEvent = new CustomEvent("myLLARegistrationStepSubmitted");
							document.dispatchEvent(step2SubmissionEvent);
						}
					}
				});
			}
		});
	}
});